/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Kind of insurance.   (german: Versicherungs Sparte)   (bipro-datamodell::Sparte)     * `MotorVehicle`                      - german: Kraftfahrt, Kfz allgemein   * `MotorVehicleLiability`             - german: Kfz-Haftpflicht   * `MotorVehicleFullyComprehensive`    - german: Kfz-Vollkasko   * `MotorVehiclePartialComprehensive`  - german: Kfz-Teilkasko   * `PrivateLiability`                  - german: Privathaftpflicht
 */
export const InsuranceSector = {
  MotorVehicle: 'MotorVehicle',
  MotorVehicleLiability: 'MotorVehicleLiability',
  MotorVehicleFullyComprehensive: 'MotorVehicleFullyComprehensive',
  MotorVehiclePartialComprehensive: 'MotorVehiclePartialComprehensive',
  PrivateLiability: 'PrivateLiability',
} as const;
export type InsuranceSector = (typeof InsuranceSector)[keyof typeof InsuranceSector];
